/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveExtraSimulationRecapCustomerAgreementMutation($input: SaveExtraSimulationRecapCustomerAgreement_M_simulation_recapInput!) {
    saveExtraSimulationRecapCustomerAgreement_M_simulation_recap(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
